import React from "react";
import "./footer.css";
//import whatsapp from "../Photos/whatsapp-logo.png"
export default function Footer() {
  return (
    <div className="foot">
    <p className="foot-p">Call us at : +91 9797343030</p>
    
  </div>
  );
}
  